import { useState, useRef } from "react";
import { Box, Text, Button as ThemeUIButton } from "theme-ui";
import { useDispatch } from "react-redux";

import { useTranslation } from "hooks";
import ModalCenter from "../ModalCenter";
import * as styles from "./ModalVideo.styles";
import { Button } from "components";
import { VideoPlayIcon, VideoPauseIcon } from "components/icons";
import { displayCompareModal } from "store/app/appSlice";

export default function ModalVideo({
  isTopMostModal,
  onClose,
  label,
  details,
  video,
}) {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  // Video playing
  const [videoIsPlaying, setVideoIsPlaying] = useState(false);

  const videoRef = useRef();

  const onPlayClick = () => {
    setVideoIsPlaying(true);
    videoRef.current.play();
  };

  const onPauseClick = () => {
    setVideoIsPlaying(false);
    videoRef.current.pause();
  };

  const onVideoEnded = () => {
    setVideoIsPlaying(false);
  };

  return (
    <ModalCenter onClose={onClose} isTopMostModal={isTopMostModal}>
      <Box sx={styles.modalContainer}>
        <Box sx={styles.modalVideoContainer}>
          <video ref={videoRef} onEnded={onVideoEnded} width="360" height="360">
            <source src={video.url} type="video/mp4" />
            {t("Your browser does not support the video tag.")}
          </video>
          {videoIsPlaying ? (
            <ThemeUIButton
              onClick={onPauseClick}
              variant="unstyled"
              sx={styles.videoPauseButton}
              id="modal-video-play-button"
            >
              <VideoPauseIcon />
            </ThemeUIButton>
          ) : (
            <ThemeUIButton
              onClick={onPlayClick}
              variant="unstyled"
              sx={styles.videoPlayButton}
            >
              <VideoPlayIcon />
            </ThemeUIButton>
          )}
        </Box>
        <Box sx={styles.modalContentContainer}>
          <Box sx={styles.modalTitleContainer}>
            <Text variant="h4Light" sx={styles.modalHeader}>
              {t("Blade Pattern")}
            </Text>
            <Text sx={styles.modalHeaderLabel}>{label}</Text>
          </Box>
          <Box sx={styles.modalContent}>
            {details.map((detail) => {
              return (
                <Text key={detail.value}>
                  {detail.label + ": "}
                  <Text sx={styles.modalContentText}>{detail.value}</Text>
                </Text>
              );
            })}
          </Box>
          <Box>
            <Button
              variant="primary"
              size="medium"
              isRound
              onClick={() => {
                dispatch(
                  displayCompareModal({
                    item: label,
                  })
                );
              }}
            >
              {t("Compare")}
            </Button>
          </Box>
        </Box>
      </Box>
    </ModalCenter>
  );
}
